'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LightBulbWithGear = function LightBulbWithGear(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("style", null, '.cls-1 { fill: none; }')), React__default["default"].createElement("path", {
    className: "cls-1",
    d: "M0,0H24V24H0V0Z"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("circle", {
    cx: "12",
    cy: "8.92",
    r: "1.49"
  }), React__default["default"].createElement("path", {
    d: "M9,21c0,.5,.4,1,1,1h4c.6,0,1-.5,1-1v-1h-6v1Z"
  }), React__default["default"].createElement("path", {
    d: "M12,2c-3.9,0-7,3.1-7,7,0,2.4,1.2,4.5,3,5.7v2.3c0,.5,.4,1,1,1h6c.6,0,1-.5,1-1v-2.3c1.8-1.3,3-3.4,3-5.7,0-3.9-3.1-7-7-7Zm3.1,6.92c0,.06,0,.12,0,.18l.96,.73-1.24,2.15-1.11-.47c-.1,.06-.21,.13-.32,.18l-.15,1.19h-2.48l-.15-1.2c-.11-.05-.21-.11-.32-.18l-1.11,.47-1.24-2.15,.96-.73c0-.05,0-.12,0-.18s0-.12,0-.18l-.96-.73,1.24-2.15,1.11,.47c.1-.06,.21-.13,.32-.18l.15-1.19h2.48l.15,1.2c.11,.05,.21,.11,.32,.18l1.11-.47,1.24,2.15-.96,.73c0,.06,0,.12,0,.18Z"
  })));
};

var LightBulbWithGear$1 = iconStyles()(LightBulbWithGear);

module.exports = LightBulbWithGear$1;
